module.exports = __webpack_public_path__ + "images/Question.2602a1ba154cc40a279d81315d4d8398.svg";